import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import styles from './table.css';

import { SUPPORT_URL } from 'constants.js';
import Translate from 'utils/translate';

import { Download } from 'components';

class RowExpanded extends Component {
  render() {
    let { row, display, expanded, background, rowLength } = this.props;

    let releaseNotes = '';
    let sha256 = <Translate stringID="label.notAvailable" defaultValue="Not Available" />;
    let md5 = <Translate stringID="label.notAvailable" defaultValue="Not Available" />;
    let note = '';
    let removed = '';
    let release ='';

    if (row.releaseNotes) {
      releaseNotes = (
        <a href={row.releaseNotes} target="_blank" style={{ marginBottom: 8 }}>
          <Translate stringID="label.releaseNotes" defaultValue="Release Notes" />
        </a>
      );
    }

    if (row.note) {
      note = (
        <p style={{ marginTop: 0 }}>
          <strong>
            <Translate stringID="label.note" defaultValue="Note" />:
          </strong>{' '}
          <i>{row.note}</i>
        </p>
      );
    }

    /** Add text explaining why an entry was removed.
     * A disabled entry can have a boolean value of true or false,
     * or a link to a KB article. If 'row.disabled' is true, the KB article explaining the reason for the removal
     * isn't yet available, so the 'removed_2' text containing the link to the KB article isn't inserted.
     * If 'row.disabled' contains a KB article link, the KB article link text is ready and the 'removed_2' text is inserted.
     */
    if (row.disabled) {
      if (row.disabled === true) {
        removed = (
          <li>
            <em>
              <Translate
                stringID="text.removed1"
                defaultValue="Access to this software has been removed. "
              />
              <Translate
                stringID="text.removed3"
                defaultValue="For more information on why a software version may be removed, see our policy for removal of older software versions."
              />
            </em>
          </li>
        );
      } else if (row.disabled && row.disabled.includes("http") === true) {
        removed = (
          <li>
            <em>
              <Translate
                stringID="text.removed1"
                defaultValue="Access to this software has been removed. "
              />
              <Translate
                stringID="text.removed2"
                params={{ link: row.disabled }}
                defaultValue="Access to this software has been removed. See the Knowledge Base support article for issue information, affected customers, and resolution steps. For more information on why a software version may be removed, see our policy for <a href='https://help.deepsecurity.trendmicro.com/release-removal.html' target='_blank'>removal of older software versions</a>."
              />
              <Translate
                stringID="text.removed3"
                defaultValue="Access to this software has been removed. See the Knowledge Base support article for issue information, affected customers, and resolution steps. For more information on why a software version may be removed, see our policy for <a href='https://help.deepsecurity.trendmicro.com/release-removal.html' target='_blank'>removal of older software versions</a>."
              />
            </em>
          </li>
        );
      }
    }
    
    return (
      <tr style={{ display: display && expanded ? 'table-row' : 'none', background: background }}>
        <td colSpan={rowLength}>
          <div styleName="details">
            <div>
              {note}
              <ul>
                <li>
                  <strong>
                    <Translate stringID="label.filename" defaultValue="Filename" />:
                  </strong>{' '}
                  <Download src={row.download} text={row.filename} disabled={row.disabled} />
                </li>
                <li>
                  <strong>
                    <Translate stringID="label.release" defaultValue="Build" />:
                  </strong>{' '}
                  {row.release ? row.release : release}
                </li>
                <li>
                  <strong>
                    <Translate stringID="label.sha256" defaultValue="SHA256" />:
                  </strong>{' '}
                  {row.sha256 ? row.sha256 : sha256}
                </li>
                <li>
                  <strong>
                    <Translate stringID="label.md5" defaultValue="MD5" />:
                  </strong>{' '}
                  {row.md5 ? row.md5 : md5}
                </li>
                {removed}
              </ul>
              {releaseNotes}
            </div>
          </div>
        </td>
      </tr>
    );
  }
}

RowExpanded.propTypes = {
  background: PropTypes.string.isRequired,
  display: PropTypes.bool.isRequired,
  row: PropTypes.object.isRequired,
  expanded: PropTypes.bool.isRequired,
};

export default CSSModules(RowExpanded, styles, { allowMultiple: true });
